import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Employee Profiles Overview</h2>
      <p>
        Employee Profiles help centralise and manage key information about your team members in one
        secure location. Use this section to maintain up-to-date records for each employee and
        support consistency across your internal workflows and documentation.
      </p>
      <p>This section allows you to manage:</p>
      <ul>
        <li>
          <strong>Personal details:&nbsp;</strong>Record each employee’s name, role, and key contact
          information.
        </li>
        <li>
          <strong>Document storage:&nbsp;</strong>Upload important documents related to employment,
          onboarding, or compliance for each team member.
        </li>
        <li>
          <strong>Profile management:&nbsp;</strong>Quickly edit or update individual employee data
          or as roles or team structures evolve.
        </li>
        <li>
          <strong>Organisational visibility:&nbsp;</strong>Keep your team directory and
          documentation clear and accurate, helping maintain accountability and ease of reference.
        </li>
      </ul>
      <p>
        <strong>Tip:&nbsp;</strong>Keeping employee profiles current ensures your HR, legal, and
        internal processes run smoothly, stay compliant and keep good records in case of any
        employee disputes.
      </p>
    </div>
  );
};

export default Preview;
